/**
 * Channel Type Options
 * Centralized channel type definitions for the application
 */

/**
 * Returns channel type options with translations
 * @param {Function} t - Translation function from i18next
 * @returns {Array} Array of channel type options
 */
export const getChannelTypeOptions = (t) => [
  { value: 'alternate_inventory_location', label: t('channelsAdd.alternateInventoryLocation') },
  { value: 'bookkeeping_company', label: t('channelsAdd.bookkeepingCompany') },
  { value: 'dealer_wholesaler_auction', label: t('channelsAdd.dealerWholesalerAuction') },
  { value: 'finance_agent', label: t('channelsAdd.financeAgent') },
  { value: 'finance_company_bank', label: t('channelsAdd.financeCompanyBank') },
  { value: 'insurance_agent', label: t('channelsAdd.insuranceAgent') },
  { value: 'insurance_company', label: t('channelsAdd.insuranceCompany') },
  { value: 'inventory_buyer', label: t('channelsAdd.inventoryBuyer') },
  { value: 'investor', label: t('channelsAdd.investor') },
  { value: 'lead_referral_source', label: t('channelsAdd.leadReferralSource') },
  { value: 'repair_service_shop', label: t('channelsAdd.repairServiceShop') },
  { value: 'sales_group_person', label: t('channelsAdd.salesGroupPerson') },
  { value: 'sales_location_branch', label: t('channelsAdd.salesLocationBranch') },
  { value: 'source', label: t('channelsAdd.source') },
  { value: 'vendor_company', label: t('channelsAdd.vendorCompany') },
  { value: 'inventory_title_location', label: t('channelsAdd.inventoryTitleLocation') },
  { value: 'repo_agent', label: t('channelsAdd.repoAgent') },
  
];

/**
 * Channel type constants (raw values)
 */
export const CHANNEL_TYPES = {
  ALTERNATE_INVENTORY_LOCATION: 'alternate_inventory_location',
  BOOKKEEPING_COMPANY: 'bookkeeping_company',
  DEALER_WHOLESALER_AUCTION: 'dealer_wholesaler_auction',
  FINANCE_AGENT: 'finance_agent',
  FINANCE_COMPANY_BANK: 'finance_company_bank',
  INSURANCE_AGENT: 'insurance_agent',
  INSURANCE_COMPANY: 'insurance_company',
  INVENTORY_BUYER: 'inventory_buyer',
  INVENTORY_TITLE_LOCATION: 'inventory_title_location',
  INVESTOR: 'investor',
  LEAD_REFERRAL_SOURCE: 'lead_referral_source',
  REPAIR_SERVICE_SHOP: 'repair_service_shop',
  SALES_GROUP_PERSON: 'sales_group_person',
  SALES_LOCATION_BRANCH: 'sales_location_branch',
  SOURCE: 'source',
  VENDOR_COMPANY: 'vendor_company',
  REPO_AGENT: 'repo_agent',
};

